import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTablePagination from '@material-ui/core/TablePagination';
import Row from './track-revenues-row';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiInput from '@material-ui/core/Input';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiBox from '@material-ui/core/Box';

const styles = () => ({
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});

const royaltyErrors = [
  'All',
  'BlockedRoyalties',
  'RecoupBalancePositive',
  'RecoupNegativeRevenue',
  'NoPlatformFee',
  'SplitPercentagesIncomplete',
  'AmbiguousISRC',
  'AlreadyCreated',
  'SplitsExcludeOwningGroup',
  'MissingISRC',
  'NoSplits',
];

const TableTrackRevenues = props => {
  const {
    handleISRCQuery,
    handleChangePage,
    handleChangeRowsPerPage,
    handleChangeError,
    trackRevenues,
    params,
    total,
    isLoading,
  } = props;

  const [selectedError, setSelectedError] = useState('All');

  //Since we are doing server side sorting, the ids need to match up with the field the server
  //found in the DB or created on the query.
  const headCells = [
    {
      id: 'gross_revenue_usd',
      numeric: true,
      label: 'Revenue',
    },
    {
      id: 'consumption_count',
      numeric: true,
      label: 'Count',
    },
    {
      id: 'royalties_created',
      numeric: true,
      label: 'Royalties Created',
    },
  ];

  const titleCell = {
    id: 'track',
    numeric: false,
    label: 'Track',
  };

  const errorCell = {
    id: 'royalty_creation_error',
    numeric: false,
    label: 'Error',
  };

  const handleFilterByErrorChange = evt => {
    setSelectedError(evt.target.value);
    handleChangeError(evt.target.value);
  };

  return (
    <MuiTableContainer>
      <MuiTable aria-label="collapsible table">
        <MuiTableHead>
          <MuiTableRow>
            <MuiTableCell colSpan={5} style={{ borderBottom: 'none' }}>
              <MuiBox display="flex" justifyContent="flex-end">
                <MuiTablePagination
                  rowsPerPageOptions={[250, 500, 1000]}
                  rowsPerPage={params.rowsPerPage}
                  count={total}
                  page={params.page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </MuiBox>
            </MuiTableCell>
          </MuiTableRow>
          <MuiTableRow>
            <MuiTableCell key={titleCell.id} align={'left'}>
              {titleCell.label}
              <MuiBox>
                <MuiInput placeholder="Search ISRC" onChange={({ target: { value } }) => handleISRCQuery(value)} />
              </MuiBox>
            </MuiTableCell>
            {headCells.map(headCell => (
              <MuiTableCell key={headCell.id} align={headCell.numeric ? 'right' : 'left'}>
                {headCell.label}
              </MuiTableCell>
            ))}
            <MuiTableCell key={errorCell.id} align={'left'}>
              <MuiBox display={'flex'} alignItems={'center'}>
                <MuiBox paddingRight={'1rem'}>
                  <MuiBox>{errorCell.label}</MuiBox>
                </MuiBox>
                <MuiSelect onChange={handleFilterByErrorChange} value={selectedError}>
                  {royaltyErrors.map(value => (
                    <MuiMenuItem key={value} value={value}>
                      {value}
                    </MuiMenuItem>
                  ))}
                </MuiSelect>
              </MuiBox>
            </MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {isLoading ? (
            <MuiTableRow>
              <MuiTableCell colSpan={5}>
                <MuiBox height={'200px'} width={'100%'} display={'flex'} justifyContent={'center'}>
                  <MuiCircularProgress />
                </MuiBox>
              </MuiTableCell>
            </MuiTableRow>
          ) : trackRevenues ? ( //react doesn't like to map over null which is somehowpossibly a state
            //There is no row.id so the stringed version of the object is how to make react no complain and not use the indexid for the key prop.
            trackRevenues.map(row => <Row key={JSON.stringify(row)} row={row} />)
          ) : null}
          <MuiTableRow>
            <MuiTableCell colSpan={5} style={{ borderBottom: 'none' }}>
              <MuiBox display="flex" justifyContent="flex-end">
                <MuiTablePagination
                  rowsPerPageOptions={[250, 500, 1000]}
                  rowsPerPage={params.rowsPerPage}
                  count={total}
                  page={params.page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </MuiBox>
            </MuiTableCell>
          </MuiTableRow>
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
};

export default withStyles(styles)(withRouter(TableTrackRevenues));
